export const common = {
  Title: "로그라피",
  TitleDesc: "당신의 이야기를 기록하세요.",
  Create: "생성하기",
  Save: "저장하기",
  Load: "불러오기",
  Close: "닫기",
  Yes: "네",
  No: "아니오",
  OK: "확인",
  All: "모두",
  Error: "에러",
  Accept: "승인",
  Cancel: "취소",
  Delete: "삭제",
  Remove: "제거",
  Accepted: "승인됨",
  Rejected: "거절됨",
  Name: "이름",
  User: "사용자",
  Users: "사용자",
  Admin: "관리자",
  Administrator: "관리자",
  Member: "구성원",
  Members: "구성원",
  Update: "업데이트",
  Upload: "업로드",
  Coupon: "쿠폰",
  Use: "사용",
  Online: "온라인",
  Offline: "오프라인",
} as const;
